import { render, staticRenderFns } from "./section-3.vue?vue&type=template&id=a37b5bcc&"
import script from "./section-3.vue?vue&type=script&lang=js&"
export * from "./section-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports